// extracted by mini-css-extract-plugin
export default {"message-wrapper":"components-general-overlay-with-message-module__message-wrapper","message-overlay":"components-general-overlay-with-message-module__message-overlay"};